module.exports = __webpack_public_path__ + "img/home-white.0f1de4f6.svg";